// Mock data pour AquaTherm Plomberie

export const companyInfo = {
  name: "AquaTherm Plomberie",
  tagline: "Dépannage & Installation",
  phone: "06 44 18 27 90",
  phoneFormatted: "0644182790",
  email: "contact@aquatherm-plomberie.fr",
  address: "14 Rue des Tilleuls, 69007 Lyon",
  rating: 4.9,
  reviewCount: 87,
  hours: {
    weekdays: "Lun–Ven : 08:00–19:00",
    saturday: "Sam : 09:00–13:00",
    sunday: "Dim : Fermé",
    emergency: "Urgences : Dépannage d'urgence 7j/7 (sur appel)"
  },
  serviceRadius: "25 km",
  zone: "Lyon & Grand Lyon"
};

export const services = [
  {
    id: 1,
    title: "Dépannage fuite & urgence",
    description: "Intervention rapide 7j/7 pour toutes vos urgences de plomberie. Fuite d'eau, canalisation percée, robinet défectueux.",
    icon: "Droplets",
    urgent: true
  },
  {
    id: 2,
    title: "Débouchage WC / évier / canalisation",
    description: "Débouchage professionnel de vos WC, éviers, douches et canalisations. Équipement adapté, résultats garantis.",
    icon: "Wrench"
  },
  {
    id: 3,
    title: "Installation robinetterie & sanitaires",
    description: "Pose et remplacement de robinets, lavabos, WC, douches. Travail soigné et conforme aux normes.",
    icon: "Hammer"
  },
  {
    id: 4,
    title: "Chauffe-eau / ballon d'eau chaude",
    description: "Installation, réparation et entretien de chauffe-eau électriques et à gaz. Dépannage rapide en cas de panne.",
    icon: "Flame"
  },
  {
    id: 5,
    title: "Rénovation salle de bain",
    description: "Rénovation complète ou partielle de votre salle de bain. Conseil, conception et réalisation sur mesure.",
    icon: "Bath"
  },
  {
    id: 6,
    title: "Recherche de fuite",
    description: "Détection de fuites invisibles avec équipement professionnel. Diagnostic précis sans casse inutile.",
    icon: "Search"
  }
];

export const detailedServices = [
  {
    id: 1,
    title: "Dépannage fuite & urgence",
    description: "Intervention rapide 7j/7 pour toutes vos urgences de plomberie. Fuite d'eau, canalisation percée, robinet défectueux, chauffe-eau en panne.",
    price: "À partir de 90€ (hors déplacement)",
    urgent: true
  },
  {
    id: 2,
    title: "Débouchage WC",
    description: "Débouchage professionnel de vos WC avec équipement adapté. Intervention rapide et efficace.",
    price: "À partir de 90€"
  },
  {
    id: 3,
    title: "Débouchage évier / douche",
    description: "Débouchage de canalisations d'évier, lavabo, douche ou baignoire. Solution durable garantie.",
    price: "À partir de 90€"
  },
  {
    id: 4,
    title: "Installation robinetterie",
    description: "Pose et remplacement de robinets, mitigeurs, mélangeurs. Large choix de modèles disponibles.",
    price: "À partir de 120€ (fourniture non comprise)"
  },
  {
    id: 5,
    title: "Installation sanitaires",
    description: "Installation complète de lavabos, WC, douches, baignoires. Travail soigné et garanti.",
    price: "Sur devis"
  },
  {
    id: 6,
    title: "Chauffe-eau électrique",
    description: "Installation, réparation et remplacement de chauffe-eau électriques. Toutes capacités.",
    price: "Sur devis"
  },
  {
    id: 7,
    title: "Ballon d'eau chaude",
    description: "Entretien et dépannage de ballons d'eau chaude. Détartrage et remplacement si nécessaire.",
    price: "Sur devis"
  },
  {
    id: 8,
    title: "Rénovation salle de bain",
    description: "Rénovation complète ou partielle : plomberie, carrelage, sanitaires. Projet clé en main.",
    price: "Sur devis personnalisé"
  },
  {
    id: 9,
    title: "Recherche de fuite",
    description: "Détection de fuites invisibles avec caméra et équipement professionnel. Rapport détaillé.",
    price: "Sur devis"
  },
  {
    id: 10,
    title: "Remplacement canalisation",
    description: "Remplacement de canalisations défectueuses ou vétustes. Mise aux normes.",
    price: "Sur devis"
  },
  {
    id: 11,
    title: "Entretien chaudière",
    description: "Entretien annuel obligatoire de votre chaudière. Intervention rapide et certificat fourni.",
    price: "À partir de 120€"
  },
  {
    id: 12,
    title: "Installation lave-linge / lave-vaisselle",
    description: "Raccordement et installation de vos appareils électroménagers. Mise en service comprise.",
    price: "À partir de 80€"
  }
];

export const whyUs = [
  {
    title: "Ponctualité garantie",
    description: "Nous respectons nos engagements : rendez-vous à l'heure, délais tenus.",
    icon: "Clock"
  },
  {
    title: "Tarifs transparents",
    description: "Devis clair et détaillé avant intervention. Pas de surprise sur la facture.",
    icon: "FileText"
  },
  {
    title: "Propreté du chantier",
    description: "Protection de votre intérieur, nettoyage après intervention. Respect de votre domicile.",
    icon: "Sparkles"
  },
  {
    title: "Conseils d'expert",
    description: "Explications claires, conseils d'entretien. On prend le temps de répondre à vos questions.",
    icon: "MessageCircle"
  }
];

export const serviceCities = [
  "Lyon 1er", "Lyon 2e", "Lyon 3e", "Lyon 4e", "Lyon 5e",
  "Lyon 6e", "Lyon 7e", "Lyon 8e", "Lyon 9e",
  "Villeurbanne", "Vénissieux", "Bron", "Caluire-et-Cuire",
  "Saint-Priest", "Vaulx-en-Velin", "Oullins", "Rillieux-la-Pape",
  "Meyzieu", "Décines-Charpieu", "Sainte-Foy-lès-Lyon",
  "Écully", "Tassin-la-Demi-Lune", "Francheville"
];

export const pricing = [
  {
    service: "Déplacement",
    price: "À partir de 45€",
    note: "Dans la zone d'intervention (25 km)"
  },
  {
    service: "Débouchage simple",
    price: "À partir de 90€",
    note: "WC, évier, lavabo"
  },
  {
    service: "Recherche de fuite",
    price: "Sur devis",
    note: "Selon complexité et équipement nécessaire"
  },
  {
    service: "Remplacement robinet",
    price: "À partir de 120€",
    note: "Hors fourniture"
  },
  {
    service: "Installation chauffe-eau",
    price: "Sur devis",
    note: "Selon type et capacité"
  },
  {
    service: "Rénovation salle de bain",
    price: "Sur devis",
    note: "Devis détaillé après visite"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sophie M.",
    city: "Lyon 7e",
    rating: 5,
    date: "Il y a 2 semaines",
    comment: "Intervention rapide pour une fuite sous l'évier. Travail propre, tarif honnête. Je recommande !"
  },
  {
    id: 2,
    name: "Marc D.",
    city: "Villeurbanne",
    rating: 5,
    date: "Il y a 1 mois",
    comment: "Très pro ! Remplacement de mon chauffe-eau en urgence. Explications claires, respect du devis."
  },
  {
    id: 3,
    name: "Claire B.",
    city: "Lyon 3e",
    rating: 5,
    date: "Il y a 3 semaines",
    comment: "Débouchage WC un dimanche. Arrivé en moins d'1h, problème résolu rapidement. Merci !"
  },
  {
    id: 4,
    name: "Thomas L.",
    city: "Caluire",
    rating: 5,
    date: "Il y a 1 semaine",
    comment: "Installation de ma nouvelle salle de bain. Travail impeccable, conseils précieux. Au top !"
  },
  {
    id: 5,
    name: "Nathalie P.",
    city: "Lyon 6e",
    rating: 5,
    date: "Il y a 2 mois",
    comment: "Recherche de fuite invisible. Équipement professionnel, détection précise. Chantier propre."
  },
  {
    id: 6,
    name: "Julien R.",
    city: "Bron",
    rating: 5,
    date: "Il y a 3 jours",
    comment: "Remplacement robinetterie cuisine. Ponctuel, efficace, prix correct. Rien à redire."
  },
  {
    id: 7,
    name: "Isabelle F.",
    city: "Lyon 8e",
    rating: 5,
    date: "Il y a 1 mois",
    comment: "Dépannage chauffe-eau en urgence. Intervention le jour même, réparation rapide. Parfait !"
  },
  {
    id: 8,
    name: "David K.",
    city: "Vénissieux",
    rating: 4,
    date: "Il y a 2 semaines",
    comment: "Bonne prestation pour débouchage canalisation. Travail efficace, peut-être un peu cher mais bon résultat."
  }
];

export const aboutContent = {
  title: "AquaTherm Plomberie, votre artisan plombier à Lyon",
  story: "Installé à Lyon depuis plus de 10 ans, AquaTherm Plomberie est votre partenaire de confiance pour tous vos travaux de plomberie. Artisan local passionné par son métier, je privilégie un travail soigné, le respect de votre intérieur et une relation de confiance avec mes clients.",
  values: [
    {
      title: "Honnêteté",
      description: "Des tarifs clairs, des conseils sincères. Je ne vous vends que ce dont vous avez vraiment besoin."
    },
    {
      title: "Pédagogie",
      description: "Je prends le temps de vous expliquer le problème et les solutions possibles. Vous décidez en connaissance de cause."
    },
    {
      title: "Ponctualité",
      description: "Votre temps est précieux. Je respecte les horaires convenus et vous préviens en cas d'imprévu."
    },
    {
      title: "Qualité",
      description: "Matériel professionnel, techniques éprouvées, finitions soignées. Mon travail est garanti."
    }
  ],
  experience: "Plus de 10 ans d'expérience",
  certifications: "Artisan qualifié • Assurance décennale • Respect des normes"
};

export const faqs = [
  {
    question: "Quel est le délai d'intervention ?",
    answer: "Pour les urgences (fuite, débouchage urgent, panne de chauffe-eau), nous intervenons généralement sous 30 à 60 minutes selon votre secteur sur Lyon et Grand Lyon. Pour les interventions planifiées, nous nous adaptons à votre emploi du temps et proposons des créneaux rapides, souvent sous 24-48h."
  },
  {
    question: "Intervenez-vous le week-end et jours fériés ?",
    answer: "Oui, nous sommes disponibles pour les urgences 7 jours sur 7, y compris les week-ends et jours fériés. Pour les dépannages urgents, appelez-nous directement au 06 44 18 27 90. Nos horaires normaux sont du lundi au vendredi de 8h à 19h et le samedi de 9h à 13h."
  },
  {
    question: "Quels modes de paiement acceptez-vous ?",
    answer: "Nous acceptons tous les modes de paiement courants : carte bancaire, espèces, chèque et virement bancaire. Le paiement s'effectue après l'intervention, une fois que vous êtes pleinement satisfait du travail réalisé. Pour les gros travaux, un acompte peut être demandé."
  },
  {
    question: "Comment obtenir un devis ?",
    answer: "Vous pouvez obtenir un devis gratuit de trois façons : en nous appelant directement au 06 44 18 27 90, en remplissant notre formulaire de contact en ligne, ou en nous écrivant sur WhatsApp. Pour les interventions urgentes, nous vous communiquons un tarif estimatif par téléphone avant de nous déplacer. Le devis définitif est toujours confirmé avant le début des travaux."
  }
];
